import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const ServiceIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="ServiceIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/service">
            <g id="Vector">
                <path
                    d="M17.9976 2C16.8955 2 15.9996 3.11992 15.9996 4.49752V8.77899C15.9996 9.00694 16.1463 9.19029 16.3286 9.19029H17.6726V11.5887C17.6726 11.8166 17.8192 12 18.0016 12C18.184 12 18.3306 11.8166 18.3306 11.5887V9.19029H19.6706C19.8529 9.19029 19.9996 9.00694 19.9996 8.77899V4.49752C19.9956 3.11992 19.0997 2 17.9976 2Z"
                    fill="currentColor"
                ></path>
                <path
                    d="M11.2863 17.299C11.412 17.9129 11.3105 18.5605 11.006 19.1115C10.6483 19.7543 10.0394 20.228 9.32887 20.4116C9.10171 20.4696 8.87455 20.4938 8.65222 20.4938C7.37142 20.4938 6.26945 19.5803 6.02295 18.3237L5.90696 17.7292C4.73248 18.6475 4.022 20.0685 4.022 21.5861C4.022 21.8084 4.20083 21.9873 4.42316 21.9873H13.4226C13.6449 21.9873 13.8238 21.8084 13.8238 21.5861C13.8189 19.7881 12.8233 18.1448 11.2863 17.299Z"
                    fill="currentColor"
                ></path>
                <path
                    d="M6.68144 10.3753C7.96993 10.0711 8.76732 8.77781 8.46246 7.48672C8.1576 6.19562 6.86592 5.39563 5.57743 5.69988C4.28893 6.00413 3.49154 7.29741 3.7964 8.5885C4.10127 9.8796 5.39294 10.6796 6.68144 10.3753Z"
                    fill="currentColor"
                ></path>
                <path
                    d="M5.43842 11.1655L6.81105 18.1785C6.98505 19.0823 7.7777 19.6961 8.65734 19.6961C8.812 19.6961 8.9715 19.6768 9.131 19.6381C10.1798 19.3723 10.784 18.2703 10.4505 17.2408L8.24652 10.4405C7.68586 10.9383 6.94155 11.2428 6.12957 11.2428C5.89274 11.238 5.66075 11.209 5.43842 11.1655Z"
                    fill="currentColor"
                ></path>
                <path
                    d="M9.329 8.03828C9.329 8.42977 9.2565 8.80676 9.13083 9.14992L15.0757 7.18763V4.4182C15.0757 4.35536 15.0757 4.2877 15.0854 4.22003L8.18836 5.58784C8.88434 6.17749 9.329 7.05713 9.329 8.03828Z"
                    fill="currentColor"
                ></path>
            </g>
        </g>
    </SvgIcon>
)
